import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGoogleColor24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#4285F4",
				d: "M21.04 12.205q-.002-.958-.164-1.841H12.4v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.616"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#34A853",
				d: "M12.4 21c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H4.357v2.332A9 9 0 0 0 12.4 21"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#FBBC05",
				d: "M7.364 13.71A5.4 5.4 0 0 1 7.082 12c0-.593.102-1.17.282-1.71V7.958H4.357A9 9 0 0 0 3.4 12c0 1.452.348 2.827.957 4.042z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#EA4335",
				d: "M12.4 6.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C16.863 3.891 14.826 3 12.4 3a9 9 0 0 0-8.043 4.958l3.007 2.332c.708-2.127 2.692-3.71 5.036-3.71"
			})
		]
	})
});
const ForwardRef = forwardRef(SvgIconGoogleColor24);
export default ForwardRef;
